<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">会員サイト利用設定変更</h1>
    </div>
    <h2 class="mt-5 mb-5">変更したい内容を選んでください</h2>
    <div class="top-menu d-flex flex-wrap justify-content-center">
      <div class="box-p-20 text-center">
        <router-link to="/settings/mail" class="btn d-block mb-3">メールアドレスを変更する</router-link>
        <p>登録しているメールアドレスを変更できます。</p>
      </div>
      <div class="box-p-20 text-center">
        <router-link to="/settings/password" class="btn d-block mb-3">パスワードを変更する</router-link>
        <p>登録しているパスワードを変更できます。</p>
      </div>
      <div class="box-p-20 text-center">
        <router-link to="/settings/delivery" class="btn d-block mb-3">配信メールを変更する</router-link>
        <p>配信するメール情報を変更できます。</p>
      </div>
      <div class="box-p-20 text-center">
        <router-link to="/settings/Unregister" class="btn d-block mb-3">利用登録を解除する</router-link>
        <p>会員サイトのご利⽤登録を解除します。</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.top-menu .box-p-20 {
  width: 50%;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .top-menu .box-p-20 {
      width: 100%;
  }
}
</style>

<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>